import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
/**
 * @internal Intended for internal use - use it on your own risk
 */
export function warnOnInvalidFilter(filter) {
  if (!filter) {
    return;
  }
  var contract = filter.contract,
    event = filter.event,
    args = filter.args;
  console.warn("Invalid contract filter: address=".concat(contract.address, " event=").concat(event, " args=").concat(args));
}
/**
 * @internal Intended for internal use - use it on your own risk
 */
export function encodeFilterData(filter, fromBlock, toBlock, blockHash) {
  if (!filter) {
    return undefined;
  }
  var contract = filter.contract,
    event = filter.event,
    args = filter.args;
  if (!contract.address || !event) {
    warnOnInvalidFilter(filter);
    return undefined;
  }
  try {
    var encodedTopics = contract.interface.encodeFilterTopics(event, args);
    if (blockHash) {
      return {
        address: contract.address,
        topics: encodedTopics,
        blockHash: blockHash
      };
    } else {
      return {
        address: contract.address,
        topics: encodedTopics,
        fromBlock: fromBlock !== null && fromBlock !== void 0 ? fromBlock : 0,
        toBlock: toBlock !== null && toBlock !== void 0 ? toBlock : 'latest'
      };
    }
  } catch (e) {
    if (e instanceof Error) {
      return e;
    } else {
      warnOnInvalidFilter(filter);
      return undefined;
    }
  }
}
/**
 * @internal Intended for internal use - use it on your own risk
 */
export function decodeLogs(filter, result) {
  if (!result || !filter) {
    return undefined;
  }
  try {
    if (result instanceof Error) {
      return {
        value: undefined,
        error: result
      };
    }
    var decodedLogs = [];
    var _iterator = _createForOfIteratorHelper(result),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var log = _step.value;
        var data = filter.contract.interface.decodeEventLog(filter.event, log.data, log.topics);
        decodedLogs.push({
          data: data,
          blockNumber: log.blockNumber,
          blockHash: log.blockHash,
          transactionIndex: log.transactionIndex,
          transactionHash: log.transactionHash,
          removed: log.removed
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return {
      value: decodedLogs,
      error: undefined
    };
  } catch (error) {
    return {
      value: undefined,
      error: error
    };
  }
}